import { RateType } from "definitions/counter-api";
import { useTranslate } from "src/i18n";

import { getPluralForm } from "./timeFormatter";

export const useRateLimitFormatter = () => {
  const { t } = useTranslate();

  const getPluralWord = (
    number: number,
    forms: {
      one: string;
      few: string;
      many: string;
      other: string;
    },
  ): string => {
    const plural = getPluralForm(number);

    switch (plural) {
      case "one":
        return forms.one;
      case "few":
        return forms.few;
      case "many":
        return forms.many;
      default:
        return forms.other;
    }
  };

  const formatRateLimit = (type: RateType, limit: number): string => {
    switch (type) {
      case "SECOND": {
        const secondForm = getPluralWord(limit, {
          one: "запрос в секунду",
          few: "запроса в секунду",
          many: "запросов в секунду",
          other: "запросов в секунду",
        });
        return t("rateLimit.perSecond", `{count} ${secondForm}`, {
          count: limit,
        });
      }
      case "MINUTE": {
        const minuteForm = getPluralWord(limit, {
          one: "запрос в минуту",
          few: "запроса в минуту",
          many: "запросов в минуту",
          other: "запросов в минуту",
        });
        return t("rateLimit.perMinute", `{count} ${minuteForm}`, {
          count: limit,
        });
      }
      case "HOUR": {
        const hourForm = getPluralWord(limit, {
          one: "запрос в час",
          few: "запроса в час",
          many: "запросов в час",
          other: "запросов в час",
        });
        return t("rateLimit.perHour", `{count} ${hourForm}`, {
          count: limit,
        });
      }
      case "DAY": {
        const dayForm = getPluralWord(limit, {
          one: "запрос в день",
          few: "запроса в день",
          many: "запросов в день",
          other: "запросов в день",
        });
        return t("rateLimit.perDay", `{count} ${dayForm}`, {
          count: limit,
        });
      }
      case "CONCURRENCY": {
        const concurrencyForm = getPluralWord(limit, {
          one: "запрос параллельно",
          few: "запроса параллельно",
          many: "запросов параллельно",
          other: "запросов параллельно",
        });
        return t("rateLimit.concurrent", `{count} ${concurrencyForm}`, {
          count: limit,
        });
      }
      default:
        return `${type}: ${limit}`;
    }
  };

  const getRateLimitTypeLabel = (type: RateType): string => {
    switch (type) {
      case "SECOND":
        return t("rateLimit.types.second", "В секунду");
      case "MINUTE":
        return t("rateLimit.types.minute", "В минуту");
      case "HOUR":
        return t("rateLimit.types.hour", "В час");
      case "DAY":
        return t("rateLimit.types.day", "В день");
      case "CONCURRENCY":
        return t("rateLimit.types.concurrent", "Параллельно");
      default:
        return type;
    }
  };

  return {
    formatRateLimit,
    getRateLimitTypeLabel,
  };
};
